/** @jsx jsx */
import React from "react"
import { jsx } from "@emotion/core"

export const SectionBlock = ({ children, ...props }) => {
  return (
    <section css={{ width: "100%" }} {...props}>
      {children}
    </section>
  )
}

export default SectionBlock
